import styled from 'styled-components';

//Caminho

export const ContainerCaminho = styled.div`
    display: flex;
    justify-content: space-evenly;
`;

export const HomeP = styled.p`
    color: #000;
    text-align: center;

    /* link */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;
    margin-right: 5px;
    cursor: pointer;
`;

export const CTp = styled.p`
    color: #848484;
    text-align: center;

    /* h6 */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;
    margin-left: 5px;
    cursor: pointer;
`;

//CcntactTipo2

export const CTContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 65px 0px;

    @media (max-width: 425px) {
        margin:30px;
    }
`;

export const CTTContainerTitulo = styled.div`
    display: inline-block;
`;

export const CTTitulo = styled.p`
    color: #000;

    text-align: center;
    /* h2 */
    font-family: Montserrat;
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px; /* 125% */
    letter-spacing: 0.2px;
    margin: 20px;

    @media (max-width: 425px) {
         font-size: 32px;
         white-space: nowrap;
    }
`;

export const CTTitulo2 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px; /* 100% */
    margin:0;
`;

export const CardListContact = styled.div`
    margin: 10px;
    padding: 10px;
    display: flex;
    gap: 25px;

    @media (max-width: 425px) {
        flex-direction:column;
        margin: 0px;
        padding: 0px;
    }
`;

export const CardContact = styled.div`
    width: 100%;
    // height: 100%;
    border-radius: 20px;
    border: 1px solid #D2D2D2;

    // @media (max-width: 425px) {
    //      width: 100%;
    //      height: 100%;
    // }

    // @media (min-width: 768px) and (max-width: 1023px){
    //      width: 100%;
    //      height: 100%;
    // }
`;

export const CardContactP1 = styled.p`
   color: #000;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    
`;

export const CardContactP2 = styled.p`
   color: #848484;
    font-family: Montserrat;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`;

export const CardContactP3 = styled.p`
    color: #848484;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
   
`;

export const ButtonContact = styled.button`
    display: inline-flex;
    padding: 10px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: #D2D2D2;
    border: none;
    cursor: pointer;
`;

export const PIniciar = styled.p`
    color: #FFF;
    font-family: Montserrat;
    font-size: 12.906px;
    font-style: normal;
    font-weight: 700;
    line-height: 19px; /* 147.215% */
    margin: 0;
`;


export const ContainerPs = styled.div`
    margin: 35px;

    @media (min-width: 768px) and (max-width: 1023px){
       margin: 30px;
    }
`;

export const ContainerButton = styled.div`
    margin: 30px 35px;
    padding: 5px 0px;

    // @media (max-width: 425px) {
    //    margin: 30px 35px;
    // }

    // @media (min-width: 768px) and (max-width: 1023px){
    //    margin: 30px 35px;
    // }
`;

export const ContainerSocial = styled.div`
    text-align: center;
`;

export const PSocial = styled.p`
    color: #848484;
    text-align: center;

    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 150% */
    letter-spacing: 0.2px;

    @media (max-width: 425px) {
       font-size: 15px;
    }

    @media (min-width: 768px) and (max-width: 1023px){
       width: 600px;
    }

    @media (min-width: 1024px){
       width: 800px;
    }

    @media (min-width: 1440px){
       width: 900px;
    }
`;


export const PSocial2 = styled.p`
    color: #848484;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 120% */
`;

export const ContactSocial = styled.div`
    display: inline-flex;
    padding: 10px;
    align-items: flex-start;
    gap: 20px;

`;

export const BotaoSocial = styled.div`
    display: flex;
    padding: 15px 40px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: #D2D2D2;
    margin-top:30px;
    cursor:pointer;
`;

export const PBotao = styled.p`
    color: #FFF;
    text-align: center;

    /* btn-text */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px; /* 157.143% */
    letter-spacing: 0.2px;
    margin:0;
`;


export const DivInputUser = styled.div`
    display: flex;
    // width: 100%;
    height: 35px;
    padding: 2px 8px 2px 2px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;

    border-radius: 5px;
    border: solid 2px #848484;
    background: #FFF;
    margin-top:5px;
`;

export const InputUser = styled.input`
    width: 100%;
     height: 100%;
     border: none;
     outline:none;
`;

export const DivInputUserTable = styled.div`
    display: flex;
    // width: 100%;
    height: 35px;
    padding: 2px 8px 2px 2px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;

    border-radius: 5px;
    border: solid 2px #848484;
    background: #FFF;
    margin-top:5px;

    @media (min-width: 768px) and (max-width: 1023px){
        width:200px;
    }
`;

export const InputUserTable = styled.input`
    width: 100%;
     height: 100%;
     border: none;
     outline:none;
`;

export const DivInputUserText = styled.div`
    display: flex;
    // width: 100%;
    height: 150px;
    padding: 2px 8px 2px 2px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;

    border-radius: 5px;
    border: solid 2px #848484;
    background: #FFF;
    margin-top:5px;
`;

export const InputUserText = styled.textarea`
    width: 100%;
     height: 100%;
     border: none;
     outline:none;
`;

export const PLabel = styled.p`
    color: #848484;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 125% */
`;


export const ButtonEnviarContato = styled.div`
    display: flex;
    padding: 15px 25px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: #848484;
`;

export const PEnviarContato = styled.p`
    color: #FFF;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 125% */
    margin:0;
`;

export const ContainerInputs = styled.div`
    margin-bottom: 20px;
`;

export const ContainerInputsTable = styled.div`
    margin-bottom: 20px;
    display: flex;
    gap:20px;

    @media (max-width: 425px) {
        flex-direction:column;
    }
`;

export const ContainerInputsBotao = styled.div`
    width:180px;
    cursor:pointer;
`;


export const ContainerImgContact = styled.div`
    width: 735px;
    height: 900px;
    display:flex;
    justify-content: center;
    align-items: center;
    background: #F5F5F5;

    @media (max-width: 425px) {
        display:none;
    }

    @media (min-width: 768px) and (max-width: 1023px){
        display:none;
    }
`;

export const ContainerFlexTabela = styled.div`
    display: flex;

    @media (max-width: 425px) {
        flex-direction:column;
    }
`;

export const ContainerTabela = styled.div`
    width: 705px;
    height: 900px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 425px) {
        width: 100%;
    }

    @media (min-width: 768px) and (max-width: 1023px){
        width: 100%;
    }
`;